export enum FundraiserSettingsAccordionEnum {
  NewDonationNotice = 'newDonationNotice', // E-postnotis vid ny gåva
  PostPaymentText = 'postPaymentText', // Text/länk efter betalning
  ReceiptToDonor = 'receiptToDonor', // E-postkvitto till givare
  GiftLetterToDonor = 'giftLetterToDonor', // E-post med gåvobrev till givare
}

export enum FundraiserSettingsSectionPrefixEnum {
  GeneralGift = 'generalGift',
  Memorial = 'memorial',
  Celebration = 'celebration',
}
